import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

  h1{
    font-size: 22px;
  }

  span{
    font-size: 10px;
  }

  body{
    overflow-x: hidden;
    p{
      margin: 0;
    }
  }

  .routerContainer {
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 0 0 0 62px;
  width: calc(100vw - 10px);
  overflow-x: hidden;
}
  ::-webkit-scrollbar {
    width: 5px;
    height: 2px;
  }
  ::-webkit-scrollbar-button {
    width: 0px;
    height: 0px;
  }
  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border: 0px none #ffffff;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #ffffff;
  }
  ::-webkit-scrollbar-thumb:active {
    background: #aaa;
  }
  ::-webkit-scrollbar-track {
    background: #666666;
    border: 0px none #ffffff;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-track:hover {
    background: #666666;
  }
  ::-webkit-scrollbar-track:active {
    background: #333333;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;
